import { getCurrencyByKey } from '@wix/locale-dataset-javascript';
const DIRECTION = {
  RTL: -1,
  LTR: 1
};
export const RTL_MARKER = '\u200F';
const getSymbol = formattedPrice => {
  const direction = isNaN(Number(formattedPrice[0])) ? DIRECTION.LTR : DIRECTION.RTL;
  let cursor = direction === DIRECTION.LTR ? 1 : formattedPrice.length - 2;
  let offset = 1;
  while (isNaN(Number(formattedPrice[cursor]))) {
    offset++;
    cursor += direction;
  }
  const symbol = direction === DIRECTION.LTR ? formattedPrice.slice(0, offset) : formattedPrice.slice(-offset);
  return symbol;
};
export const PriceFormattingConverter = {
  createPriceFormatter: (locale, currencyCode) => {
    const wixCurrency = getCurrencyByKey(currencyCode.toUpperCase());
    const {
      fraction,
      symbol
    } = wixCurrency ?? {};
    const formatOptions = {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'symbol',
      minimumFractionDigits: fraction ?? 0,
      maximumFractionDigits: fraction ?? 2
    };
    const displayFormatter = new Intl.NumberFormat(locale, formatOptions);
    const latinDigitFormatter = new Intl.NumberFormat(locale, {
      ...formatOptions,
      numberingSystem: 'latn'
    });
    return price => {
      const res = displayFormatter.format(price).trim().replace(RTL_MARKER, '');
      const intlSymbol = getSymbol(
      // Use the latin digit formatter to get the symbol
      // to avoid locales with special digits characters issues
      latinDigitFormatter.format(price).trim().replace(RTL_MARKER, ''));
      if (intlSymbol && symbol) {
        return res.replace(intlSymbol, symbol);
      }
      return res;
    };
  }
};
//# sourceMappingURL=price-formatting-converter.js.map